import { createTransportByUrl, Session } from '../../core';
import { RoomId, Publisher, ParticipantId } from '../../plugins/VideoRoomPlugin';
import { VideoRoomParticipant } from './participant';
import { VideoRoomSubscriber } from './subscriber';
import { VideoRoomPublisher } from './publisher';
import { makeRandomString } from '../../utility';

export class VideoRoomSignaling {
    private readonly opaqueId = 'AutowareDriveVideoRoom' + makeRandomString(12);

    async create(server: string) {
        const transport = createTransportByUrl(server);
        const session = await Session.create(transport);
        session.startPolling();

        return session;
    }

    async waitForPublishers(
        session: Session,
        room: RoomId,
        username: string,
        callback: (event: {
            event: 'published';
            connection: VideoRoomParticipant;
            publishers: Publisher[];
        } | {
            event: 'unpublished';
            connection: VideoRoomParticipant;
            publisherId: ParticipantId;
        }) => void
    ) {
        const participant = await VideoRoomParticipant.create(
            session,
            this.opaqueId
        );

        participant.onpublishers = publishers => callback({ event: 'published', connection: participant, publishers });
        participant.onunpublished = publisherId => callback({ event: 'unpublished', connection: participant, publisherId });

        await participant.join(room, username);
        return participant;
    }

    async prepareSubscribe(session: Session) {
        return await VideoRoomSubscriber.create(session, this.opaqueId);
    }

    async subscribe(
        sub: VideoRoomSubscriber,
        config: RTCConfiguration,
        room: RoomId,
        publisher: Publisher,
        privateId: string | undefined,
        callback: (stream: MediaStream, kind: string) => void
    ) {
        await sub.connect(config, callback);

        await sub.join(room, publisher.id, privateId);
    }

    async publish(
        session: Session,
        config: RTCConfiguration,
        room: RoomId,
        username: string,
        localStream: MediaStream
    ) {
        try {
            const pub = await VideoRoomPublisher.create(session, this.opaqueId);

            await pub.join(room, username);

            await pub.connect(config);
            await pub.publish(localStream, { audio: true, video: true });
        } catch (err) {
            console.error('oh my', err);
        }
    }
}
